"use client";

import renderOembed from "@/lib/iframeFunction";
import React from "react";

type BravoDealInfoProps = {
  description: string; // HTML string from DB
};

const BravoDealInfo: React.FC<BravoDealInfoProps> = ({ description }) => {
  const html = (description || "").trim();
  const plainText = html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!plainText) return null;

  return (
    <div className="max-w-[1090px] mx-auto mt-4 px-3 sm:px-6 md:px-8 py-4 sm:py-6 bg-gray-100 rounded-lg shadow-md text-gray-800">
  <div
    className="prose prose-sm md:prose-base lg:prose-lg text-gray-800 max-w-full"
    dangerouslySetInnerHTML={{ __html: renderOembed(html) }}
  />
</div>

  );
};

export default BravoDealInfo;
